<span
	class="{{ 'status-clr-' + (sanitizedStatus ? sanitizedStatus : 'default') }}"
	[ngClass]="{
		'text-nowrap': !textWrappingIsAllowed
	}"
>
	{{
		i18nPath
		? getI18nString( i18nPath )
		: getI18nString( sanitizedStatus ? 'shared.status.' + sanitizedStatus : null )
	}}
</span>
